import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../img/Logo_signcast_big-1080x322.png";
import Hamburger from "./Hamburger";
import { AiOutlineMenu, AiOutlineSetting, AiOutlineLogout } from "react-icons/ai";
import useAuthStore from "../store/authStore";
import SettingsPanel from "./setting/SettingsPanel";

const Header = ({ toggleSidebar, isOpen }) => {
  const { user, logout } = useAuthStore();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const navigate = useNavigate();
  
  const fullName = user?.fullName || "User";
  const email = user?.email || "user@example.com";
  
  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };
  
  const handleLogout = () => {
    const success = logout();
    if (success) {
      navigate('/login');
    }
  };

  const openSettings = () => {
    setShowSettings(true);
    setShowDropdown(false); // Close dropdown when opening settings
  };
  
  const closeSettings = () => {
    setShowSettings(false);
  };
  
  return (
    <>
      <div className="z-100 bg-white fixed top-0 w-full left-0 h-14 border-b z-50 ">
        <div className="fixed left-5 top-3">
          <img className="w-28" src={logo} alt="logo" />
        </div>
        <div
          className="text-menu_item_on absolute right-6 z-50 top-3 lg:hidden"
          onClick={toggleSidebar}
        >
          <Hamburger
            icon={<AiOutlineMenu className="text-black" size={30} />}
          />
        </div>

        <div className="items-center flex flex-row absolute lg:right-4 right-16 top-2 z-50 justify-center">
          {/* User welcome and name in a separate div */}
          <div className="flex flex-col mr-2" style={{ lineHeight: '1.2' }}>
            <div className="text-xs text-gray-500 block">Welcome</div>
            <div className="text-sm font-bold text-gray-700 block">{fullName}</div>
          </div>
          
          <div className="relative">
            {/* Circle button that toggles dropdown - with enhanced interactions */}
            <div 
              className="flex-shrink-0 flex justify-center items-center rounded-full w-10 h-10 bg-blue-100 cursor-pointer 
                        transition duration-200 ease-in-out hover:bg-blue-200 active:bg-blue-300 focus:outline-none focus:ring-2 focus:ring-blue-400"
              onClick={toggleDropdown}
              onMouseEnter={() => {/* You can add more hover effects here */}}
              onMouseLeave={() => {/* You can add effects for mouse leaving */}}
            >
              <svg
                className={`w-5 h-5 transition-transform duration-200 ease-in-out ${showDropdown ? 'transform rotate-180 text-blue-700' : 'text-blue-500'}`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
            
            {/* Dropdown menu */}
            {showDropdown && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50 border border-gray-200 
                             animate-fadeIn">
                {/* User info section */}
                <div className="px-4 py-2 border-b border-gray-100">
                  <p className="text-sm font-semibold text-gray-800">{fullName}</p>
                  <p className="text-xs text-gray-500">{email}</p>
                </div>
                
                {/* Settings option */}
                <div 
                  className="px-4 py-2 flex items-center hover:bg-gray-50 cursor-pointer transition duration-150"
                  onClick={openSettings}
                >
                  <AiOutlineSetting className="text-gray-600 mr-2" size={16} />
                  <p className="text-sm text-gray-700">Settings</p>
                </div>
                
                {/* Logout option */}
                <div 
                  className="px-4 py-2 flex items-center hover:bg-gray-50 cursor-pointer transition duration-150"
                  onClick={handleLogout}
                >
                  <AiOutlineLogout className="text-red-400 mr-2" size={16} />
                  <p className="text-sm text-red-400">Logout</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Settings Panel */}
      <SettingsPanel isOpen={showSettings} onClose={closeSettings} />
    </>
  );
};

export default Header;
